export default __webpack_public_path__ + "static/media/440.3fa1054b.png";